import React, { useEffect, useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Col, Collapse, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import ApiNavbar from "../components/global/ApiNavbar";
const faqs = [
    {
        id: "1",
        question: "How do I obtain an API key?",
        answer: "API keys are generated upon subscribing to the API service. Your keys are emailed to the email address on file during the subscription process. Please check your email for your API keys. Keys can take up to 48 hours to be generated.",
    },
    {
        id: "2",
        question: "What happens if I lose my API private key?",
        answer: "Your API private key was emailed to you during the subscription process. If for some reason you cannot locate your registration email that includes the private token, you will need to create a new account to have a new token generated. Please contact us for assistance.",
    },
    {
        id: "3",
        question:
            "How can I render the golf hole maps like they are in the examples?",
        answer: `The API allows you read access to the Golfbert golf course maps geodata. Once you have the API calling correctly, you can render the maps any way you see fit. In most cases, using an SVG plugin such as <a href="#">D3.js<a/> works best, as in our hole examples. You will be able to apply color fills, strokes, texture patterns and more however you like!`,
    },
    {
        id: "4",
        question:
            "Can I use a satellite image instead of SVG graphics on my golf hole maps?",
        answer: `Absolutely. You can render your hole maps on top of a <a href="#">Javascript Maps API<a/> instead of a graphical SVG plugin if you wish. You should be aware that satellite images can be heavy and may cause your app to perform slower during the rendering process. We recommend using an SVG plugin to reduce weight.`,
    },
    {
        id: "5",
        question:
            "Can I see an example of my favorite golf course using the API?",
        answer: `In most cases, yes. Browse Golfbert.com's <a href="/api/overview">golf course database<a/> to see thousands of examples of existing golf courses rendered with the same API data.`,
    },
    {
        id: "6",
        question: "How many courses are in the golf course database?",
        answer: "We have streamlined our data efforts to offer the most optimized set of courses for app developers. We have already completed the most popular golf courses in the United States — over 12,500 — and are adding around 200 new courses per month!",
    },
    {
        id: "7",
        question: "Can I request a course to be added to the API database?",
        answer: "We are constantly adding new courses to the API database. If you notice a course is missing, you can always request new courses to be added to our API. If you are an active subscriber in the monthly All Courses tier, we guarantee completion of up to five new course mapping requests per month.",
    },
    {
        id: "8",
        question: "What countries does the API include?",
        answer: `Currently the API is limited to the United States, but we have received numerous requests for additional countries. If you have a country request, please <a href="/api/support">contact us<a/> and we will prioritize our expansion list.`,
    },
    {
        id: "9",
        question: "How to search for courses by radius",
        answer: `As for searching within a lng/lat radius, this would involve some minor engineering effort on your end. Please have a look at the below example. This should explain how you can arrive at a radius around a device/search location:<br /><br />
        -----------------------------<br /><br />
Based on this initial API request (<a href="https://api.golfbert.com/v1/courses/?lat=41.63495&long=-87.53467">https://api.golfbert.com/v1/courses/?lat=41.63495&long=-87.53467</a>) which is very precise, let’s assume this might be the course that is close to you. Now let’s say that your own GPS coordinates (where you are standing when trying to locate courses) is the one from this second API request that you are showing (<a href="https://api.golfbert.com/v1/courses/?lat=41.6349501&long=-87.5434247">https://api.golfbert.com/v1/courses/?lat=41.6349501&long=-87.5434247</a>).<br /><br />

As you can see, this API request yields nothing. If you start shaving decimals from those coordinates and retrying the API request, you eventually get to a radius of search large enough to include golf courses in your vicinity. For example, <a href="https://api.golfbert.com/v1/courses/?lat=41.6&long=-87.5">https://api.golfbert.com/v1/courses/?lat=41.6&long=-87.5</a>, yields:<br /><br />

<img src="https://1drv.ms/i/c/9e951c618a80a01e/IQTEMJDe1KeAR5NqGKhFqNL5AQK9U7r2R6rp7ck9WWzzCII?width=1024" class="faq-image-radius" /><br /><br />

Once you have the courses, with a simple calculation, you can figure out which one is closest to your exact location.<br /><br />

Basically, you have to search a large enough rectangle to find the courses included in that rectangle. Anecdotally, single decimal precision equates to a rectangle large enough to cover a large city (or county), two decimals a town and three a neighborhood. Most Golfbert courses come with 5 decimals of precision.`,
    },
    {
        id: "10",
        question: "How to use Hole Rotation",
        answer: `We rotate all the points using the farthest tee box from the green as origin for the rotation<br /><br />
        
        Let’s take <a href="https://golfbert.com/courses/Kellogg_Golf_Course/8470:Hole_2">Kellogg GC hole 2</a>. The coordinates min/max that we provide aim to paint something like this:<br /><br />

        <img src="https://1drv.ms/i/c/9e951c618a80a01e/IQQCWH1j1PWgTb2TMNCah_3bAV4DLCOl-172iloLwqWliMA?width=1024" class="faq-image-rotation" /><br />
        <img src="https://1drv.ms/i/c/9e951c618a80a01e/IQRuG1xjEsbiSaL5oFj7T3J2Aa6E35IHzUWxWYKYXvXaxhQ?width=1024" class="faq-image-rotation" /><br /><br />
        
        If you convert the rotation from radians to degrees you get:<br /><br />

        <img src="https://1drv.ms/i/c/9e951c618a80a01e/IQSEcoapFV5QQ6fjwrDxDRuHAfwMfm-NsJ8lZUevem741tc?width=1024" class="faq-image-rotation" /><br /><br />
        
        If you rotate that minX, minY, maxX, maxY coordinates by 95 degrees you should get:<br /><br />

        <img src="https://1drv.ms/i/c/9e951c618a80a01e/IQQQi0A5DRe9Sab9upSKRaTxAVpjeZ7LJh1dOq-q3ntN0g0?width=1024" class="faq-image-rotation" /><br /><br />
        
        Rotating a rectangle on the GPS plane by some degrees is well documented on the internet.<br /><br />
        
        Regarding the radians vs degrees, this is largely a legacy thing in our db, but you don’t have to convert to degrees to rotate, you can rotate a rectangle using radians directly.`,
    },
    {
        id: "11",
        question: "The API just isn't doing what I want. Can someone help me?",
        answer: `Of course! Please <a href="/api/support">contact us<a/> and we will help you wil anything you need.`,
    },
    // Add more FAQs here
];

const FAQ = () => {
    const [open, setOpen] = useState("");

    const toggle = (id) => {
        setOpen((prevOpen) => (prevOpen === id ? "" : id));
    };

    const renderArrow = (id) => {
        if (open === id) {
            return <FaChevronDown />;
        } else {
            return <FaChevronRight />;
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            {/* <ApiNavbar /> */}
            <div className="faq mb-5">
                <Container className="py-2">
                    <h1>API FAQ</h1>
                    <p>
                        Below are some frequently asked questions. If you are
                        still having trouble using the API, please{" "}
                        <Link className="faq__link-to" to="/api/support">
                            contact us
                        </Link>{" "}
                        and we will help you out.
                    </p>
                    {faqs.map(({ id, question, answer }) => (
                        <Row key={id} className="my-3">
                            <Col
                                md="12"
                                onClick={() => toggle(id)}
                                className={`faq__head-question d-flex ${
                                    open === id ? "faq__ques-active" : ""
                                }`}
                            >
                                <div className="pr-3 fs--16 fw--400">
                                    {renderArrow(id)}
                                </div>
                                <div className="faq__main-ques">{question}</div>
                            </Col>
                            <Collapse isOpen={open === id}>
                                <Col>
                                    <div
                                        className="fs--14 f--400 font-poppins text-muted "
                                        dangerouslySetInnerHTML={{
                                            __html: answer,
                                        }}
                                    />
                                </Col>
                            </Collapse>
                        </Row>
                    ))}
                </Container>
            </div>
        </>
    );
};

export default FAQ;
